import { SorterResult } from 'antd/lib/table/interface';
import { isArray, isBoolean, isEmpty, isNil, isObject } from 'lodash';
import { TFunction } from 'react-i18next';

import { AuthZeroSortOrder, SortOrder } from 'api';
import moment from 'moment';

export const getShowTotal = (
	total: number,
	range: [number, number],
	t: TFunction,
) =>
	t('table.showTotal', {
		count: total,
		range0: range[0],
		range1: range[1],
	});

export const getAPISorter = (
	sorter: SorterResult<any> | SorterResult<any>[],
	isAuthZeroOrder: boolean | undefined = false,
) => {
	const sortField = isArray(sorter) ? sorter[0] : sorter;
	const ascValue: any = isAuthZeroOrder ? AuthZeroSortOrder.ASC : SortOrder.ASC;
	const descValue: any = isAuthZeroOrder
		? AuthZeroSortOrder.DESC
		: SortOrder.DESC;

	return {
		sortField: (sortField.column as any).APISortField,
		sortOrder: sortField.order === 'ascend' ? ascValue : descValue,
	};
};
export const getDateValue = (value?: Date) => {
	return moment.parseZone(value).local().format('MM-DD-YYYY h:mmA z');
};
export const getCellValue = (value: any) => {
	if (
		isNil(value) ||
		value === '' ||
		isBoolean(value) ||
		(isObject(value) && isEmpty(value))
	) {
		return '—';
	}

	return value;
};

export const formatNumber = (number: number | string, digits: number = 2) => {
	if (isNaN(Number(number)) || number === null) {
		return number;
	}
	var result = Number(number).toLocaleString('en-US', {
		maximumFractionDigits: digits,
		minimumFractionDigits: digits,
	});
	if (Number(result) === 0) {
		result = '0';
	}
	return result;
};
